import { ProjectSkillEditorPage } from "@/features/projects/project-skill-editor.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/new",
)({
  component: ProjectSkillEditorPage,
});
